'use client';

import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import type { GTMEventGlycerinMarketingClick } from '@packages/tracking/src/types/events';
import { GlycerinMarketingType } from '@packages/tracking/src/types/enums';
import type { SlotLinkProps } from '../Base/Slot.Link';
import { SlotLink } from '../Base/Slot.Link';
import { usePaybackLink } from '../../shared/usePaybackLink';

export const PaybackSlot = (props: Pick<SlotLinkProps, 'priority'>) => {
  const { href, label } = usePaybackLink();
  const { headerInformation, i18n } = useConfig();
  const dispatch = useTracking();

  const handleClick = () => {
    const language = i18n.defaultLocale.split('-')[0] as 'de' | 'fr' | 'en' | 'nl';
    const basePath = headerInformation?.[language]?.canonical;

    if (basePath) {
      const fullUrl = new URL(href, basePath).toString();
      dispatch<GTMEventGlycerinMarketingClick>({
        event: 'MarketingClick',
        MarketingClickData: {
          category: 'payback anmeldelayer',
          marketingType: GlycerinMarketingType.CAMPAIGN,
          campaignType: 'kundenbindung',
          label: 'payback-promo',
          target: fullUrl,
        },
      });
    }
  };

  return (
    <SlotLink {...props} href={href} label={label} onClick={handleClick}>
      <div className="icon-emp-payback-colored h-4 w-4" />
    </SlotLink>
  );
};
